import React, {useMemo} from 'react';
import {classes, style, vars} from './doppe-layout9-profile-view-template.st.css';
import {BymoTemplateMetadataInferBymoPageProps} from '../../../doppe-sdk';
import {RatioMaintainer} from '@wix/devzai-utils-react';
import {arrayFirst} from '@wix/devzai-utils-common';
import {FlexLayout} from '@wix/devzai-common-client';
import {doppeHideableValueIsVisible} from '../../../client-server-common/types/doppe-hideable-value';
import {DoppeHideableValueRenderer} from '../../doppe-hideable-value-renderer/doppe-hideable-value-renderer';
import {DoppeProfileNameAutoSource} from '../../../client-server-common';
import {
    BymoTemplateSpeedDialTemplateMetadata
} from '../../bymo-templates/bymo-template-speed-dial/bymo-template-speed-dial.metadata';
import {DoppeLayoutRoot} from '../dopp-layouts-components/doppe-layout-root/doppe-layout-root';
import {DoppLayoutBackground} from '../dopp-layouts-components/dopp-layout-background/dopp-layout-background';
import {DoppLayoutContent} from '../dopp-layouts-components/dopp-layout-content/dopp-layout-content';
import {
    DoppLayoutBackgroundMedia
} from '../dopp-layouts-components/dopp-layout-background-media/dopp-layout-background-media';
import {DoppePageHeroPhoto} from '../../doppe-page-hero-photo/doppe-page-hero-photo';
import {DoppePageProfilePicture} from '../../doppe-page-profile-picture/doppe-page-profile-picture';
import {
    DoppePageProfileNameView,
    DoppePageProfileNameViewVerifiedCheckAppearance
} from '../../doppe-page-profile-name-view/doppe-page-profile-name-view';
import {BymoPageLayout, useBymoPageLayout} from '../../bymo-page-style/bymo-page-style';
import {DoppeLayoutBioText} from '../dopp-layouts-components/doppe-layout-bio-text/doppe-layout-bio-text';
import {DoppeLayoutSocialLinks} from '../dopp-layouts-components/doppe-layout-social-links/doppe-layout-social-links';
import {DoppeLayoutPageContent} from '../dopp-layouts-components/doppe-layout-page-content/doppe-layout-page-content';

export const DoppeLayout9ProfileViewTemplate = React.memo(function DoppeLayout5ProfileView(props: BymoTemplateMetadataInferBymoPageProps<typeof BymoTemplateSpeedDialTemplateMetadata>) {
    const {
        profilePictureLinkInBio,
        profilePictureMaskingShape,
        bioText,
        bioTextMaxLines,
        socialLinks,
        heroPhotos,
        heroPhotosOpacity,
    } = props;

    const hasProfileImage = useMemo(() => {
        return doppeHideableValueIsVisible(profilePictureLinkInBio);
    }, [profilePictureLinkInBio]);

    const bymoPageLayout = useBymoPageLayout();

    const isMobile = bymoPageLayout === BymoPageLayout.Narrow;
    const heroRatio = isMobile ? 340 / 440 : 460 / 510;

    return (
        <DoppeLayoutRoot
            className={style(classes.root, {})}
            style={{
                [vars.opacity]: `${heroPhotosOpacity}%`,
            }}
            hideHoppBanner={props.removeHoppBanner}
        >
            <DoppLayoutBackground
                className={style(classes.coverBackground, {})}
            >
                <DoppLayoutBackgroundMedia
                    className={style(classes.pageWithCoverBackgroundView, {})}
                />
            </DoppLayoutBackground>
            <DoppLayoutContent
                className={style(classes.content)}
            >
                <div
                    className={style(classes.profileView, FlexLayout.column.default)}
                >
                    <DoppeLayoutBioText
                        className={style(classes.bioText, {})}
                        bioText={bioText}
                        bioTextMaxLines={bioTextMaxLines}
                        lineHeight={'18px'}
                    />
                    <RatioMaintainer
                        className={style(classes.profileImageContainer, {})}
                        widthHeightRatio={heroRatio}
                    >
                        <DoppePageHeroPhoto
                            className={style(classes.heroPhoto)}
                            mediaResource={heroPhotos === null ? null : (arrayFirst(heroPhotos) ?? null)}
                            layoutSpec={{
                                widthHeightRatio: heroRatio
                            }}
                            widthSpec={{contentRelativeWidth: heroRatio}}
                        />
                        <div className={style(classes.heroPhotoOverlay, {})}/>
                        <div
                            className={style(classes.profileImageAndName, {}, FlexLayout.row.alignToCenter)}
                        >
                            <div
                                className={style(classes.profileImageAndNameContent, {}, FlexLayout.column.alignToCenter, FlexLayout.fillRemainingHorizontalSpace)}
                            >
                                {
                                    hasProfileImage ?
                                        <DoppeHideableValueRenderer
                                            hideableValue={profilePictureLinkInBio}
                                            renderFunction={profilePicture => (
                                                <DoppePageProfilePicture
                                                    className={style(classes.profileImage, {})}
                                                    profilePicture={profilePicture}
                                                    maskingShape={profilePictureMaskingShape}
                                                    size={120}
                                                />
                                            )}
                                        />
                                        :
                                        null
                                }
                                <DoppePageProfileNameView
                                    className={style(classes.profileName, {}, FlexLayout.verticallyJustifyToEnd)}
                                    defaultProfileNameAutoSource={DoppeProfileNameAutoSource.AccountName}
                                    verifiedCheckAppearance={DoppePageProfileNameViewVerifiedCheckAppearance.Superscript}
                                />
                            </div>
                        </div>
                    </RatioMaintainer>
                    <DoppeLayoutSocialLinks
                        className={style(classes.socialLinks, {})}
                        socialLinks={socialLinks}
                    />
                </div>
                <DoppeLayoutPageContent
                    className={style(classes.pageContent, {})}
                    pageProps={props}
                    searchHeaderClassName={style(classes.supportText)}
                />
            </DoppLayoutContent>
        </DoppeLayoutRoot>
    )
});

